import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

let airApiUrl = `${process.env.REACT_APP_BASE_URL}air_3minutes`;
let kitHavaApiUrl = `${process.env.REACT_APP_BASE_URL}kithava_3minutes`;
let BNZNApiUrl = `${process.env.REACT_APP_BASE_URL}test_bnzn`;
let tokenStr = process.env.REACT_APP_API_TOKEN;

export const fetchStations = createAsyncThunk("stations/fetchStations", () => {
  return axios
    .get(airApiUrl, { headers: { Authorization: `Token ${tokenStr}` } })
    .then((response) => response.data);
});

export const fetchKitHava = createAsyncThunk("stations/fetchKitHava", () => {
  return axios
    .get(kitHavaApiUrl, { headers: { Authorization: `Token ${tokenStr}` } })
    .then((response) => response.data.KITHAVA);
});

export const fetchBNZN = createAsyncThunk("stations/fetchBNZN", () => {
  return axios
    .get(BNZNApiUrl, { headers: { Authorization: `Token ${tokenStr}` } })
    .then((response) => response.data.BNZN);
});

const stationsSlice = createSlice({
  name: "stations",
  initialState: {
    stationsLoading: true,
    stationsData: {
      SAPA: [],
      ESPS: [],
      OSPM: [],
      SATA: [],
      KitHava: [],
      BNZN: [],
      SATA2: [],
    },
    stationsError: "",
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStations.pending, (state) => {
        state.stationsLoading = true;
      })
      .addCase(fetchStations.fulfilled, (state, action) => {
        state.stationsLoading = false;
        state.stationsData = {
          ...state.stationsData,
          ...action.payload,
        };
        state.stationsError = "";
      })
      .addCase(fetchStations.rejected, (state, action) => {
        state.stationsLoading = false;
        state.stationsData = {
          SAPA: [],
          ESPS: [],
          OSPM: [],
          SATA: [],
          KitHava: [],
          SATA2: [],
        };
        state.stationsError = action.error.message;
      })
      .addCase(fetchKitHava.pending, (state) => {
        state.stationsLoading = true;
      })
      .addCase(fetchKitHava.fulfilled, (state, action) => {
        state.stationsLoading = false;
        state.stationsData.KitHava = action.payload;
        state.stationsError = "";
      })
      .addCase(fetchKitHava.rejected, (state, action) => {
        state.stationsLoading = false;
        state.stationsData.KitHava = [];
        state.stationsError = action.error.message;
      })
      .addCase(fetchBNZN.pending, (state) => {
        state.stationsLoading = true;
      })
      .addCase(fetchBNZN.fulfilled, (state, action) => {
        state.stationsLoading = false;
        state.stationsData.BNZN = action.payload;
        state.stationsError = "";
      })
      .addCase(fetchBNZN.rejected, (state, action) => {
        state.stationsLoading = false;
        state.stationsData.BNZN = [];
        state.stationsError = action.error.message;
      });
  },
});

export default stationsSlice.reducer;
